import { extendTailwindMerge } from "tailwind-merge";
const colorFamilies = [
    'primary',
    'neutral',
    'actionPrimary',
    'actionSecondary',
    'actionShop',
    'actionCritical',
    'favorite',
    'success',
    'error',
    'benefit',
    'urgency',
    'customer',
    'caution',
    'highlight',
    'priceSale',
    'priceRetail',
    'marketingBrand',
    'promoPrimary',
    'penny',
    'pennyAccents',
    'vipMember',
    'vipBlue',
    'vipGold',
    'vipPlatinum'
];
const colorShades = Array.from({
    length: 15
}, (_, i)=>(i + 1).toString());
const allColorVariants = colorFamilies.flatMap((family)=>colorShades.map((shade)=>`${family}-${shade}`));
const typographyStyleNames = [
    'display1',
    'display2',
    'display3',
    ...Array.from({
        length: 6
    }, (_, i)=>`heading${i + 1}`),
    ...Array.from({
        length: 4
    }, (_, i)=>`subheading${i + 1}`),
    ...Array.from({
        length: 3
    }, (_, i)=>`body${i + 1}`),
    ...Array.from({
        length: 3
    }, (_, i)=>`action${i + 1}`),
    'article',
    'disclaimer',
    'label',
    ...Array.from({
        length: 6
    }, (_, i)=>`priceSuper-heading${i + 1}`),
    ...Array.from({
        length: 3
    }, (_, i)=>`priceSuper-body${i + 1}`),
    ...Array.from({
        length: 6
    }, (_, i)=>`priceSub-heading${i + 1}`),
    ...Array.from({
        length: 3
    }, (_, i)=>`priceSub-body${i + 1}`),
    'icon-8',
    'icon-10',
    'icon-12',
    'icon-16',
    'icon-18',
    'icon-20',
    'icon-24',
    'icon-28',
    'icon-32',
    'icon-36',
    'icon-40',
    'icon-48',
    'icon-64',
    'icon-80',
    'icon-96'
];
const radiusNames = [
    'none',
    'xsm',
    'sm',
    'md',
    'lg',
    'xl',
    '2xl',
    '3xl',
    'full',
    'action-sm',
    'action-md',
    'action-lg',
    'action-xl'
];
const shadowNames = [
    'overlay-md',
    'overlay-lg',
    'input-focus',
    'input-hover',
    'input-error',
    'sm',
    'md',
    'lg',
    'xl',
    'penny-sm',
    'penny-md'
];
const twMergeConfig = {
    extend: {
        classGroups: {
            'text-color': [
                {
                    text: allColorVariants
                }
            ],
            'bg-color': [
                {
                    bg: allColorVariants
                }
            ],
            'border-color': [
                {
                    border: allColorVariants
                }
            ],
            'border-x-color': [
                {
                    'border-x': allColorVariants
                }
            ],
            'border-y-color': [
                {
                    'border-y': allColorVariants
                }
            ],
            'border-s-color': [
                {
                    'border-s': allColorVariants
                }
            ],
            'border-e-color': [
                {
                    'border-e': allColorVariants
                }
            ],
            'border-t-color': [
                {
                    'border-t': allColorVariants
                }
            ],
            'border-r-color': [
                {
                    'border-r': allColorVariants
                }
            ],
            'border-b-color': [
                {
                    'border-b': allColorVariants
                }
            ],
            'border-l-color': [
                {
                    'border-l': allColorVariants
                }
            ],
            'divide-color': [
                {
                    divide: allColorVariants
                }
            ],
            'outline-color': [
                {
                    outline: allColorVariants
                }
            ],
            'ring-color': [
                {
                    ring: allColorVariants
                }
            ],
            'ring-offset-color': [
                {
                    'ring-offset': allColorVariants
                }
            ],
            'accent-color': [
                {
                    accent: allColorVariants
                }
            ],
            'caret-color': [
                {
                    caret: allColorVariants
                }
            ],
            fill: [
                {
                    fill: allColorVariants
                }
            ],
            stroke: [
                {
                    stroke: allColorVariants
                }
            ],
            'font-size': [
                {
                    text: typographyStyleNames
                }
            ],
            rounded: [
                {
                    rounded: radiusNames
                }
            ],
            'rounded-s': [
                {
                    'rounded-s': radiusNames
                }
            ],
            'rounded-e': [
                {
                    'rounded-e': radiusNames
                }
            ],
            'rounded-t': [
                {
                    'rounded-t': radiusNames
                }
            ],
            'rounded-r': [
                {
                    'rounded-r': radiusNames
                }
            ],
            'rounded-b': [
                {
                    'rounded-b': radiusNames
                }
            ],
            'rounded-l': [
                {
                    'rounded-l': radiusNames
                }
            ],
            'rounded-ss': [
                {
                    'rounded-ss': radiusNames
                }
            ],
            'rounded-se': [
                {
                    'rounded-se': radiusNames
                }
            ],
            'rounded-ee': [
                {
                    'rounded-ee': radiusNames
                }
            ],
            'rounded-es': [
                {
                    'rounded-es': radiusNames
                }
            ],
            'rounded-tl': [
                {
                    'rounded-tl': radiusNames
                }
            ],
            'rounded-tr': [
                {
                    'rounded-tr': radiusNames
                }
            ],
            'rounded-br': [
                {
                    'rounded-br': radiusNames
                }
            ],
            'rounded-bl': [
                {
                    'rounded-bl': radiusNames
                }
            ],
            shadow: [
                {
                    shadow: shadowNames
                }
            ]
        }
    }
};
const twMerge = extendTailwindMerge(twMergeConfig);
export { twMerge, twMergeConfig };
